import { notifications } from '@mantine/notifications'

/**
 * Show a notification using Mantine's notification system
 * @param {Object|string|ReactNode} data - The notification data or content
 * @param {ReactNode} data.content - The notification message (if data is an object)
 * @param {string} data.text - Alternative to content for simple text messages
 * @param {number} data.timeout - How long to show the notification in ms (default: 3000, -1 for no auto-close)
 * @param {string} data.color - The notification color/type
 * @param {string} data.type - Alternative way to specify type ('error' maps to red color)
 */
export function showNotification(data) {
    // Handle both string and object formats
    const content = typeof data === 'object'
        ? (data?.content || data?.text || data)
        : data
    const timeout = data?.timeout !== undefined ? data.timeout : 3000
    const autoClose = timeout === -1 ? false : timeout
    let color = data?.color

    // Map type to color
    if (!color && data?.type === 'error') {
        color = 'red'
    }

    // Detect error messages by checking if content is a React element with ErrorMessage class
    if (!color && content?.props?.className?.includes('ErrorMessage')) {
        color = 'red'
    }

    notifications.show({
        message: content,
        autoClose,
        color,
        withCloseButton: true,
    })
}

